import { TeaCupIllustration } from '../../assets/illustrations';
import { Headings } from '../Headings';
import { Flex } from '../Layout';
import { Link } from '../Link';
import { Text } from '../Text';
import { ErrorPageProps } from './ErrorPage';

export const ErrorPage500 = ({ title, message, links }: ErrorPageProps) => {
  return (
    <>
      <Headings.H1>{title || 'Något gick fel'}</Headings.H1>
      <TeaCupIllustration width={[180, 180, 220]} />
      <Text size="large">
        {message || (
          <>
            Vi arbetar med att lösa problemet.
            <br />
            Vänligen försök igen om en stund.
          </>
        )}
      </Text>
      <Flex flexDirection="column" rowGap={20}>
        {links &&
          links.map(({ linkText, linkUrl }, index) => {
            return (
              <Link to={linkUrl} key={index} fontSize="large">
                {linkText}
              </Link>
            );
          })}
      </Flex>
    </>
  );
};
